export default __webpack_public_path__ + "static/media/005.6d039cc9.webp";